module.exports = __webpack_public_path__ + "fonts/Source_Serif_4-normal-900-cyrillic.47fa8f9.woff2";